import { Component, OnInit, EventEmitter } from "@angular/core";
import { ApiRequestService } from "../../../_services/api-request.service";
import { MaterializeAction } from "angular2-materialize";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import * as _ from "lodash";
import { saveAs } from 'file-saver';

declare var Materialize: any;
declare var $: any;

@Component({
  selector: "app-compensation-claim",
  templateUrl: "./compensation-claim.component.html",
  styleUrls: ["./compensation-claim.component.css"],
})
export class CompensationClaimComponent implements OnInit {
  compensationClaimModal = new EventEmitter<string | MaterializeAction>();

  pdfview: SafeResourceUrl;
  pdfview1: SafeResourceUrl;

  bodyParts = [];
  bodypart_name = "";
  page_content = "body_parts";
  patientConsentFile: any = "";
  patientHistoryFile: any = "";

  FileDetail0: any;
  FileDetail1: any;

  treatments: any = [];

  freeTrailCount = 0;

  loader = false;
  DataResult: any;
  FixedColumn;
  FilterDataResult;

  handler: any = null;
  allow: any = 'false';
  interval: any;

  comp_type: any;

  title = '';

  RawData: any;

  constructor(
    private apirequest: ApiRequestService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getTrailCount();
    this.get_list();
    this.loadStripe();
    let manage_claim = localStorage.getItem("manage_claim");
    if (manage_claim == null) {
      localStorage.setItem("manage_claim", 'false');
    } else {
      this.allow = manage_claim;
    }
  }

  msg_view(msg_data) {
    $(document).ready(function () {
      Materialize.toast(msg_data.toString(), 3000, "grey darken-4");
    });
  }

  get_list() {
    this.loader = true;
    let data = {
      action: "get_list",
    };
    //console.log(data);
    this.apirequest.customize_flow(data).subscribe((res) => {
      //console.log(res);
      if (res.status == "True") {
        this.loader = false;
        this.bodyParts = res.msg.body_parts;
      } else {
        this.loader = false;
        this.msg_view(res.msg);
      }
    });
  }

  get_bodypart_name(item) {
    this.bodypart_name = item;
  }

  next_section() {
    if (this.page_content == "body_parts") {
      this.page_content = "upload_section";
    }
  }

  back_section() {
    if (this.page_content == "upload_section") {
      this.page_content = "body_parts";
    }
    this.patientConsentFile = "";
    this.patientHistoryFile = "";
  }

  onChange(file: any, type) {
    if (type == "patient_consent") {
      this.FileDetail0 = file;
      this.patientConsentFile = URL.createObjectURL(file);
      this.pdfview = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.patientConsentFile
      );
    } else if (type == "patient_history") {
      this.FileDetail1 = file;
      this.patientHistoryFile = URL.createObjectURL(file);
      this.pdfview1 = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.patientHistoryFile
      );
    }
    // this.pdfview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getResult() {
    this.loader = true;
    this.patientConsentFile = "";
    this.patientHistoryFile = "";
    let input = new FormData();
    input.append("action", "save_form_data");
    input.append("Patient_Consent_Form", this.FileDetail0);
    input.append("Patient_Medical_History", this.FileDetail1);
    this.apirequest.customize_flow(input).subscribe((res) => {
      console.log(res);
      if (res.status == "True") {
        //this.msg_view(res.msg);
        this.treatments = res.Patient_Consent_Form_Response;
        this.treatments.push(...res.Patient_Medical_History_Response);
        if (this.treatments) {
          this.fetchChartData(res.log_id);
        } else {
          this.patientConsentFile = "";
          this.patientHistoryFile = "";
          let patient_consent_file: any = document.getElementById('patient_consent_file');
          let patient_history_file: any = document.getElementById('patient_history_file');
          let FileInput: any = document.getElementById('FileInput');
          let FileInput1: any = document.getElementById('FileInput1');
          patient_consent_file.value = '';
          patient_history_file.value = '';
          FileInput.value = '';
          FileInput1.value = '';
          this.msg_view('Empty list of treatments for Graph Query');
          this.loader = false;
        }
      } else {
        this.ErrorCase('Empty list of treatments for Graph Query');
      }
    });
  }

  fetchChartData(lid:any) {
    let treatments_list = _.uniq(this.treatments);
    //console.log(treatments_list);
    let data = {
      action: "search_portal_query",
      body_part: this.bodypart_name,
      decision: "all",
      treatment: treatments_list,
      case_no: 10,
      startdate: "",
      enddate: "",
      details_list: ["Final Determination"],
      flag: this.comp_type,
      mode: 'data',
      log_id:lid
    };
    //console.log(data);

    this.apirequest.customize_flow(data).subscribe((res) => {
      console.log(res);
      if (res.status == "True") {
        this.loader = false;
        // this.title = 'The analysis is in the process against your given document.';
        this.title = 'The Analysis process against your given document.';
        // this.DataResult = 'We will get back to you over your email once the results are ready.';
        this.DataResult = 'A Result has been sent to your registered email in the format of Workers Comp.';
        this.RawData = res.msg.data;
        this.setTableData();
        this.allow = 'false';
        localStorage.setItem("manage_claim", 'false');
        this.getTrailCount();
      } else if (res.status == "False") {
        this.loader = false;
        this.msg_view(res.msg);
        // this.title = 'The analysis is in the process against your given document.';
        // this.DataResult = "We will get back to you over your email once the results are ready.";
        // this.setTableData();
        // this.allow = 'false';
        // localStorage.setItem("manage_denclaim", 'false');
        this.getTrailCount();
      } else {
        this.ErrorCase('Empty list of treatments for Graph Query');
      }
    });
  }

  modal_close() {
    this.compensationClaimModal.emit({ action: "modal", params: ["close"] });
    setTimeout(() => {
      this.page_content = "body_parts";
      this.bodypart_name = "";
    }, 1000);
    this.patientConsentFile = "";
    this.patientHistoryFile = "";
  }

  compensationClaimModalOpen() {
    this.comp_type = 'free';
    if (this.freeTrailCount !== 0) {
      this.compensationClaimModal.emit({ action: "modal", params: ["open"] });
    } else {
      this.msg_view("Free Trial Expired");
    }
  }

  ErrorCase(data) {
    this.loader = false;
    this.msg_view(data);
    this.modal_close();
  }

  setTableData() {
    this.FilterDataResult = this.RawData;
    this.FixedColumn = Object.keys(this.RawData[0]);
    console.log(this.FixedColumn);
    if (this.page_content == "upload_section") {
      this.page_content = "result_section";
    }
  }

  loadStripe() {

    if (!window.document.getElementById('stripe-script')) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://checkout.stripe.com/checkout.js";
      s.onload = () => {
        this.handler = (<any>window).StripeCheckout.configure({
          key: 'pk_test_51H6t5qCgKYFbXxLVrSkC98u2RmWiLS1GrbHiEtDl28ko2gz5e7WzPOkTXdKdpmvTPL2Z2nRfBgeX7gVkrkh3dLrq00cWs0M71V',
          locale: 'auto',
          token: function (token: any) {
            // You can access the token ID with `token.id`.
            // Get the token ID to your server-side code for use.
            //console.log(token)
            alert('Payment Success!!');
            this.router.navigate(['/user/dashboard'])
          }
        });
      }

      window.document.body.appendChild(s);
    }
  }

  pay(amount: any) {
    this.comp_type = 'payment';
    //console.log(this.allow);

    if (this.allow == 'false') {
      var email = "info@otacon.us";
      var handler = (<any>window).StripeCheckout.configure({
        key: 'pk_test_51H6t5qCgKYFbXxLVrSkC98u2RmWiLS1GrbHiEtDl28ko2gz5e7WzPOkTXdKdpmvTPL2Z2nRfBgeX7gVkrkh3dLrq00cWs0M71V',
        locale: 'auto',
        token: function (token: any) {
          // You can access the token ID with `token.id`.
          // Get the token ID to your server-side code for use.
          //console.log(token)
          localStorage.setItem("manage_claim", 'true');
          // alert('Token Created!!');
        }
      });

      handler.open({
        name: 'Otacon Paygate',
        email: email,
        description: '',
        amount: amount * 100
      });
    }

    this.interval = setInterval(() => {
      this.allow = localStorage.getItem('manage_claim');
      if (this.allow == 'true') {
        this.compensationClaimModal.emit({ action: "modal", params: ["open"] });
        clearInterval(this.interval);
      }
    }, 10);

  }

  getTrailCount() {
    let data = {
      action: "get_access_count",
    };
    //console.log(data);
    this.apirequest.customize_flow(data).subscribe((res) => {
      //console.log(res);
      if (res.email) {
        //console.log(res.email);
        this.freeTrailCount = res.data_count;
      } else {
        this.msg_view(JSON.stringify(res));
      }
    });
  }

  download() {
    var blob = new Blob([JSON.stringify(this.DataResult, undefined, 2)], { type: "text/plain;charset=utf-8" });
    saveAs(blob, "Result.json");
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/compensation-claim/compensation-claim.component.ts